import { parseDataForForm, parseDataForSubmit } from 'common/helpers/asset-helper'
import { Asset } from 'common/models'

export const parseAssetListForForm = (assetList: Asset[]) => {
  return assetList?.map((asset, index) => {
    return {
      ...parseDataForForm(asset),
      index,
    }
  })
}

export const parseAssetListForSubmit = (assetList: Asset[]) => {
  return assetList?.map(asset => {
    return {
      ...parseDataForSubmit(asset),
    }
  })
}
